
import {
  Toast,
  PullRefresh,
  SwipeCell,
  Dialog,
  PasswordInput,
  NumberKeyboard,
} from "vant";
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
import { Component, Vue, Watch } from "vue-property-decorator";
import { sendSms, checkSms } from "@/req/user";
import NavBar from "@/components/navBar.vue";
@Component({
  components: { PullRefresh, SwipeCell, NavBar },
})
export default class Logout extends Vue {
  public count = 0;
  public isLoading = false;
  public code = "";
  public showKeyboard = true;
  public smsCountTime = 0;

  //   @Watch("code")
  //   public codeChange() {
  //       this.
  //   }
  public onClickLeft() {
    // this.$router.go(-1);
    // this.$fn.sendIos(1);
    const u = navigator.userAgent;
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android安卓
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios苹果
    if (isiOS) {
      (window as any).sendIos();
    } else {
      this.$router.push("/my");
    }
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public created() {
    //   url截取token
    const obj: any = this.$fn.parseQuery(window.location.href);
    // const token = this.$route.query.token;
    // 打印token
    // Dialog.alert({
    //   title: "token",
    //   message: `${obj.token}`,
    //   theme: "round-button",
    // }).then(() => {
    //   // on close
    // });
    // console.log(obj);
    if (obj.token) {
      this.$fn.cookies.setToken(obj.token);
      this.$fn.cookies.setShowNav(1);
    }
    if (obj.device) {
      this.$fn.cookies.setIsios(obj.device);
    }
    if (obj.version) {
      this.$fn.cookies.setVersion(obj.version);
    }
  }
  public mounted() {
    this.getSmsCode();
  }
  //   短信验证码倒计时
  public smsCountDown() {
    if (this.smsCountTime !== 0) {
      this.smsCountTime--;
      setTimeout(() => {
        this.smsCountDown();
      }, 1000);
    }
  }
  // 获取验证码
  public async getSmsCode() {
    const res = await sendSms({ a: "1" });
    if (res.code == 200) {
      this.smsCountTime = 60;
      this.smsCountDown();
    }
  }
  // 验证后跳转
  public async toRoute() {
    const obj = {
      phone: this.$store.state.user.info.phone,
      code: this.code,
    };
    const res = await checkSms(obj);
    if (res.code == 200) {
      this.$router.push("/authentication/upload");
    } else {
      Toast(res.msg);
    }
  }
}
